import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ComparatorClass;
function Comparator() {
  if (ComparatorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Comparator');
    ComparatorClass = $;
  }
  return ComparatorClass;
}
//region block: exports
export {
  Comparator as Comparator2b3maoeh98xtg,
};
//endregion

//# sourceMappingURL=ComparatorJs.mjs.map
